import React from "react";
import {OrdersUIProvider} from "./OrdersUIContext";
import OrdersListCmp from "./OrdersListCmp";

export default function Orders() {
    return (
        <OrdersUIProvider>
            <OrdersListCmp/>
        </OrdersUIProvider>
    )
}